export enum THEME {
  VELTHUIS = 'velthuis',
  XPERT = 'xpert',
}

const isVelthuis = import.meta.env.THEME === THEME.VELTHUIS

const appContext = import.meta.env.THEME

const xpertTelNumber = '+31887785210'
const velthuisTelNumber = '+31887785201'

const VELTHUIS_CAMPAIGN_PREFIX = 'CAM_'

export {
  appContext,
  isVelthuis,
  VELTHUIS_CAMPAIGN_PREFIX,
  velthuisTelNumber,
  xpertTelNumber,
}
